import { render, staticRenderFns } from "./TicketHistory.vue?vue&type=template&id=059c13f3"
import script from "./TicketHistory.vue?vue&type=script&lang=js"
export * from "./TicketHistory.vue?vue&type=script&lang=js"
import style0 from "./TicketHistory.vue?vue&type=style&index=0&id=059c13f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports